import css from './index.module.scss';
import { EFSupportLeft } from '@/components/UI/svg/Support';
import { useGlobal } from '@/utils/useGlobal';

export default function SupportTile({ title, lang, content = null }: any) {
    const { Link, useRouter } = useGlobal();
    const { locale } = useRouter();
    return (
        <div className={`${css.accessoriesType} supportTitleH5`}>
            <h3>
                <EFSupportLeft />
                <span>{title}</span>
            </h3>
            {['uk', 'de', 'fr', 'es', 'it'].includes(locale as string) && lang?.date1 && lang?.date2 && (
                <div className="policy-date">
                    <div className="date-item">{lang?.date1}</div>
                    <div className="date-item">{lang?.date2}</div>
                </div>
            )}
            {content?.text && (
                <div className="content">
                    <Link href={content?.link} className={'content-text'}>
                        {content?.text}
                        {' >'}
                    </Link>
                </div>
            )}
        </div>
    );
}
